import CounterModel from "../models/CounterModel";

const CounterViewModel = {
  getCounter: async () => {
    return await CounterModel.fetchCounter();
  },

  getPaginatedImageKeys: (counter, pageNumber, itemsPerPage = 12) => {
    const startIndex = (pageNumber - 1) * itemsPerPage;
    const keys = [];
    for (let i = 0; i < itemsPerPage; i++) {
        const key = counter - startIndex - i;
        // Published artefacts are numbered 1..counter; image 0 exists in the
        // bucket but is gated (the edge returns 403 for it), so never surface
        // it — otherwise the last page shows a broken/empty 0.jpg tile.
        if (key >= 1) {
            keys.push(key);
        }
    }
    return keys;
  }
};

export default CounterViewModel;
